import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	chip: {
		margin: 1,
		maxWidth: "100%",
		height: "auto",
		borderRadius: "12px",
		boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
		"& .MuiChip-label": {
			whiteSpace: "normal",
			wordBreak: "break-word",
			lineHeight: "1.2",
			padding: "6px 10px",
			fontSize: "0.8rem",
			fontWeight: "500",
			color: "white",
		},
	},
	selectContainer: {
		"& .MuiSelect-select": {
			minHeight: "50px",
			display: "flex",
			alignItems: "flex-start",
			padding: "8px 12px",
			borderRadius: "8px",
		},
		"& .MuiOutlinedInput-root": {
			borderRadius: "8px",
		},
	},
	menuItem: {
		padding: "8px 16px",
		"&:hover": {
			backgroundColor: "#f5f5f5",
		},
	},
	menuItemSelected: {
		backgroundColor: "#e3f2fd !important",
		color: "#1976d2",
		fontWeight: "500",
		"&:hover": {
			backgroundColor: "#bbdefb !important",
		},
	},
	menuItemIcon: {
		marginRight: "8px",
		fontSize: "16px",
	},
	placeholder: {
		color: "#999",
		fontStyle: "italic",
		fontSize: "0.9rem",
	},
}));

const IntegrationSelect = ({ selectedIntegrationId, onChange, title = "Integración (Opcional)", disabled = false }) => {
	const classes = useStyles();
	const [integrations, setIntegrations] = useState([]);
	const selectedId = selectedIntegrationId === "" || selectedIntegrationId == null
		? ""
		: Number(selectedIntegrationId);

	useEffect(() => {
		fetchIntegrations();
	}, []);

	const fetchIntegrations = async () => {
		try {
			const { data } = await api.get("/queueIntegration");
			setIntegrations(data.queueIntegrations || []);
		} catch (err) {
			toastError(err);
		}
	}

	const handleChange = e => {
		onChange(e);
	};

	return (
		<div>
			<FormControl fullWidth margin="dense" variant="outlined" className={classes.selectContainer}>
				<InputLabel shrink={selectedId !== ""}>{title}</InputLabel>
				<Select
					label={title}
					labelWidth={60}
					value={selectedId === "" || Number.isNaN(selectedId) ? "" : selectedId}
					onChange={handleChange}
					disabled={disabled}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={selected => {
						if (!selected || selected === "") {
							return <span className={classes.placeholder}>Seleccionar integración...</span>;
						}
						
						const integration = integrations.find(i => Number(i.id) === Number(selected));
						
						if (integration && integration.name) {
							return (
								<Chip
									variant="outlined"
									style={{ backgroundColor: "#9c27b0" }}
									label={integration.name}
									className={classes.chip}
								/>
							);
						} else {
							return <span className={classes.placeholder}>Seleccionar integración...</span>;
						}
					}}
				>
					<MenuItem value="">
						<span className={classes.placeholder}>Sin integración</span>
					</MenuItem>
					{integrations.map(integration => {
						const isSelected = Number(selectedId) === Number(integration.id);
						
						return (
							<MenuItem 
								key={integration.id} 
								value={Number(integration.id)}
								className={isSelected ? classes.menuItemSelected : classes.menuItem}
							>
								<span className={classes.menuItemIcon}>
									{isSelected ? '✓' : '○'}
								</span>
								{integration.name}
								{isSelected && (
									<span style={{ marginLeft: 'auto', fontSize: '0.8rem', color: '#1976d2' }}>
										Seleccionado
									</span>
								)}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
};

export default IntegrationSelect;
